export default __webpack_public_path__ + "static/char-thumb-38-87890ec8b351eaee53ad101ebf0fb0c8.png";